/**
 * Validate if userPermission contains all requiredPermission
 *
 * @param {Object} permission - Object contains requiredPermission and userPermission.
 * @param {string[]} permission.requiredPermission - List of required permission.
 * @param {string[]} permission.userPermission - List of user permission.
 */
export default function permissionRequiredAll({
  requiredPermission = [],
  userPermission = [],
}) {
  for (const rPermission of requiredPermission) {
    if (
      !userPermission.find(
        uPermission => uPermission.toLowerCase() === rPermission.toLowerCase()
      )
    ) {
      return false;
    }
  }

  return true;
}
